import { useEffect, useRef, useState } from "react";

export default function Secured() {
  useEffect(() => {
    window.location.href = "/";
  }, []);

  return null;
}
